<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'DevicesStatistics',
  components: {CommonTable},
  data() {
    return {
      searchs: [/*{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }*/{
        name: 'startCreateTime',
        placeholder: '开始时间',
        type: 'dateTime'
      },
        {
          name: 'endCreateTime',
          placeholder: '结束时间',
          type: 'dateTime'
        }],
      permission: {
        add: 'devicesStatistics:add',
        update: 'devicesStatistics:update',
        delete: 'devicesStatistics:delete',
        deleteBatch: 'devicesStatistics:deleteBatch'
      },
      url: {
        get: '/devicesStatistics/listByCondition',
        add: '/devicesStatistics/add',
        update: '/devicesStatistics/update',
        delete: '/devicesStatistics/delete',
        delete_batch: '/devicesStatistics/deleteBatch',
        status: '/devicesStatistics/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, /*{
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      },*/
        {
          field: 'dayTime',  // 字段名
          label: '零点时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'devices',  // 字段名
          label: '设备编号',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'acquisitionQuantity',  // 字段名
          label: '获取数量',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'numberOfCallbacks',  // 字段名
          label: '回调数量',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'dayTime',  // 字段名
            label: 'dayTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入dayTime',
            rules: [
              {required: true, message: 'dayTime不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'number',  // 字段名
            label: 'number',  // 字段显示名称
            type: 'input',
            placeholder: '请输入number',
            rules: [
              {required: true, message: 'number不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'acquisitionQuantity',  // 字段名
            label: 'acquisitionQuantity',  // 字段显示名称
            type: 'input',
            placeholder: '请输入acquisitionQuantity',
            rules: [
              {required: true, message: 'acquisitionQuantity不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'numberOfCallbacks',  // 字段名
            label: 'numberOfCallbacks',  // 字段显示名称
            type: 'input',
            placeholder: '请输入numberOfCallbacks',
            rules: [
              {required: true, message: 'numberOfCallbacks不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
